import {
  createRouterMiddleware,
  createRouterReducer,
} from '@lagunovsky/redux-react-router'
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { reducer as accountReducer } from './account/ducks'
import appReducer from './app-reducer'
import history from './core/services/history'
import { reducer as ticketsReducer } from './home/ducks'

const routerReducer = createRouterReducer(history)
const routerMiddleware = createRouterMiddleware(history)

const persistConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['app'],
}

const appPersistConfig = {
  key: 'app',
  storage: storage,
  blacklist: ['festivalName'],
}

const rootReducer = combineReducers({
  router: routerReducer,
  account: accountReducer,
  app: persistReducer(appPersistConfig, appReducer),
  tickets: ticketsReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).prepend(routerMiddleware),
})

export type RootState = ReturnType<typeof rootReducer>

export type AppDispatch = typeof store.dispatch
type DispatchFunc = () => AppDispatch
export const useAppDispatch: DispatchFunc = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
